export default __webpack_public_path__ + "static/media/ship1.c64ab0f0.png";